import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router';

import { incidentNotify } from '@/api/client';
import Oops from '@/components/pages/Oops/Oops';

interface Props {
  children: React.ReactNode;
}

const MyErrorBoundary = ({ children }: Props) => {
  const location = useLocation();

  const myErrorHandler = (error: Error, info: { componentStack: string }) => {
    // Skip alerting for chunk load errors (expected during deployments)
    const message = error.message || '';
    if (
      message.includes('Failed to fetch dynamically imported module') ||
      (message.includes('Loading chunk') && message.includes('failed')) ||
      error.name === 'ChunkLoadError'
    ) {
      // Let the global chunk-error-handler.js trigger reload
      return;
    }

    incidentNotify({
      summary: error.message,
      component_stack: info.componentStack,
      url: location.pathname,
      query: location.search,
      // Forwarded so the server-side noise gate can drop alerts coming from
      // preview/internal hosts (Vercel, ngrok, NROC, *.preview.moveo.ai).
      host: window.location.host,
      origin: window.location.origin,
      error_name: error.name,
    });
  };

  return (
    <ErrorBoundary FallbackComponent={Oops} onError={myErrorHandler}>
      {children}
    </ErrorBoundary>
  );
};

export default MyErrorBoundary;
